module.exports = __webpack_public_path__ + "static/media/icon-bell.840b8052.svg";